export const TEN_MINUTES = 10 * 60 * 1000;
export const FIVE_MINUTES = 5 * 60 * 1000;
export const MINUTE = 60 * 1000;
export const SECOND = 1000;
export const ONE_DAY = 24 * 60 * 60 * 1000;
export const DAYS_30 = 30 * 24 * 60 * 60 * 1000;

export const MY_JOBS_PAGE_SIZE = 10;
export const MY_JOBS_DEFAULT_MILES_FILTER = 35;
export const MY_JOBS_DISTANCE_WARNING_MILES = 100;
export const MY_JOBS_PROFILE_COMPLETION_THRESHOLD = 90;
export const SEARCH_DEBOUNCE_MS = 300;
export const MIN_SEARCH_CHARS = 2;

// Unit conversion constants
export const KM_TO_MILES = 0.621371;

// Layout constants
export const NAVBAR_HEIGHT = 75;

export const PaymentRating = [
  { index: 6, value: 5, title: '< 1 week' },
  { index: 7, value: 5, title: '1-3 weeks' },
  { index: 8, value: 4.25, title: '3-5 weeks' },
  { index: 9, value: 3, title: '6-8 weeks' },
  { index: 1, value: 1, title: '9+ weeks' },
  { index: null, value: null, title: 'Not Yet Paid' },
];

export type IPaymentRating = (typeof PaymentRating)[0];

export const BUTTON_COOLDOWN_DURATION_MS = 3000;

export const YES = 'YES';
export const NO = 'NO';
